export default __webpack_public_path__ + "static/media/card_bg_5.cf50b887.png";